import cookies from "cookiesjs"

export default {
    methods: {
        getFileStreamUrl(file) {
            return __API_URL__ + '/customer_internal_document_files/' + file.id + '/stream?token=' + cookies("token")
        },
        getFileDownloadUrl(file) {
            return __API_URL__ + '/customer_internal_document_files/' + file.id + '/download?token=' + cookies("token")
        }
    }
}


// WEBPACK FOOTER //
// ./client/mixins/customerInternalDocumentFiles.js